import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, debounceTime, fromEvent, map, merge, Observable, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { BaseRequestService } from 'app/_services/base.service';
import { MyToastrService } from 'app/_services/toastr.service';
import {MatSort, Sort} from '@angular/material/sort';
import { DateTime } from 'luxon';
import * as _moment from 'moment';
import {default as _rollupMoment} from 'moment';
const moment = _rollupMoment || _moment;
import { CommonService } from 'app/_services/common.services';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'l, LTS'
  },
  display: {
    dateInput: 'YYYY-MM-DD HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-romap',
  templateUrl: './romap.component.html',
  styleUrls: ['./romap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ 
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}]


})
export class RomapComponent implements OnInit {
  headers:any=[
    {
      header:'RO Code',
      column:'ro_code',
      filter:'',
      sort:true,
      visible:true,
      class:'',
      classtab:' truncate',
      type:'text',
      searchstring:'ro_code.keyword',
      issearch:true,
    },
    {
      header:'RO Name',
      column:'ro_name',
      filter:'',
      sort:true,
      visible:true,
      class:'',
      classtab:' truncate',
      type:'text',
      searchstring:'ro_name.keyword',
      issearch:true,
    }
  ]
  loadingapi:boolean;
  codeh:any=[];
  searchromap:any=[]
  colfilter:any={};
  @ViewChild(MatSort) private sort: MatSort; 
  public romasters = this.codeh.slice();
  constructor(public cs:CommonService, private baseservice:BaseRequestService, 
    private _changeDetectorRef: ChangeDetectorRef,
    ){
    this.cs.current({'tab':'RO MAP', 'count':0, 'showcount':true})
    this.searchromap = this.cs.searchdata.subscribe((change:any) =>{
      // this.colfilter = change
      // this.get_ro()
      this.romasters = this.codeh.filter(x => (x.ro_name.toLowerCase().includes(change.ro_name)))
      this._changeDetectorRef.markForCheck()
    }) 

  }


  ngOnInit(): void {
    this.get_ro()
  }

  getProperty(object: any, propertyName: any): any {
    let parts: any[]; let property: string;
    parts = propertyName.split('.'); const length = parts.length;
    let i: number;
    property = object;
    for (i = 0; i < length; i++) {
      // @ts-ignore
      property = property[parts[i]];
    }
    return property;
  }

  get_ro(){
    this.baseservice.doRequest(`/api/ro_master/ro_dropdown`, 'post', {}).subscribe((result: any) => {
      if(result && result.data && result.data.length>0){
        this.romasters=[]
        result.data.forEach(ele =>{
          if(window.location.href.includes('bpcl') && (ele.ro_code == '169718' || ele.ro_code == '244802')){
              this.romasters.push(ele)
          }
          else if(window.location.href.includes('ioml') && ele.ro_code !== '169718' && ele.ro_code !== '244802'){
            this.romasters.push(ele)
          }
          // this.rohash[ele.ro_code]=ele.ro_name
        })
        // this.romasters = result.data
        this.codeh  = JSON.parse(JSON.stringify(this.romasters))
        this.loadingapi = true
        this._changeDetectorRef.markForCheck();
      }
    })
  }

}
